module.exports = __webpack_public_path__ + "static/media/filip-walter-cv.c545aefa.pdf";